import { Reikwijdte, Traject } from "@/entities/dossier-details";
import { StationMultiSelect } from "@/features/infra";
import { SingleToggleGroupFormField } from "@/shared/components/ui/single-toggle-group-form-field.tsx";
import { ToggleGroupOption } from "@/shared/components/ui/toggle-group";
import { useFormContext, UseFormReturn, useWatch } from "react-hook-form";
import { TrajectenEditor } from "./trajecten-editor";

type ReikwijdteFormValues = {
    reikwijdte: Reikwijdte;
    stations: string[];
    trajecten: Traject[];
};

type ReikwijdteForm = UseFormReturn<ReikwijdteFormValues>;

const reikwijdteOptions: ToggleGroupOption<Reikwijdte>[] = [
    { value: Reikwijdte.Stations, label: "Station(s)" },
    { value: Reikwijdte.Trajecten, label: "Traject(en)" },
    { value: Reikwijdte.Landelijk, label: "Landelijk" },
];

export function ReikwijdtePicker() {
    const form = useSafeReikwijdteForm();
    const currentReikwijdte = useWatch({ control: form.control, name: "reikwijdte" });

    return (
        <div className="grid grid-cols-3 gap-4">
            <div className="col-span-2 grid gap-1">
                <SingleToggleGroupFormField
                    form={form}
                    name="reikwijdte"
                    options={reikwijdteOptions}
                    label="Reikwijdte"
                    dataTestId="reikwijdte-toggle-group"
                />
            </div>
            {currentReikwijdte === Reikwijdte.Stations && (
                <div className="col-span-3">
                    <StationMultiSelect
                        form={form}
                        name="stations"
                        label="Stations"
                        placeholder="Selecteer station(s)"
                        nlStationsOnly
                        badgeLabel="value"
                        data-testid="reikwijdte-stations-select"
                    />
                </div>
            )}
            {currentReikwijdte === Reikwijdte.Trajecten && (
                <div className="col-span-3">
                    <TrajectenEditor />
                </div>
            )}
        </div>
    );
}

const useSafeReikwijdteForm = (): ReikwijdteForm => {
    const form = useFormContext<ReikwijdteFormValues>();

    if (!("reikwijdte" in form.getValues())) {
        throw new Error("Form must contain a 'reikwijdte' field");
    }
    return form;
};
